import { render, staticRenderFns } from "./CreateDefect.vue?vue&type=template&id=32ab4eeb&scoped=true&"
import script from "./CreateDefect.vue?vue&type=script&lang=js&"
export * from "./CreateDefect.vue?vue&type=script&lang=js&"
import style0 from "./CreateDefect.vue?vue&type=style&index=0&id=32ab4eeb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ab4eeb",
  null
  
)

export default component.exports